












import {Component, Prop, Mixins} from 'vue-property-decorator';
import {TableItem} from "@api/models/interfaces/TableItem";
import UserMixin from '@mixins/UserMixin';
import {TooltipDirective} from '@share/directives/Tooltip';
import {IsMeetingsEnabled} from "@mixins/isMeetingsEnabled";
import {IsChatEnabled} from "@mixins/isChatEnabled";
import {PaymentAccess} from "@mixins/PaymentAccess";
import {TableRow} from "@common/table/interfaces/TableRow";
import {TableColumn} from "@common/table/interfaces/TableColumn";

@Component({
    components: {},
    directives: {TooltipDirective}
})
export default class ATableRow extends Mixins(IsMeetingsEnabled, IsChatEnabled, UserMixin, PaymentAccess) implements TableRow {
    @Prop({required: true}) fields: TableColumn[];
    @Prop({required: true}) source: TableItem;
    @Prop({required: false}) routeName: string;
    @Prop({required: false}) index: number;
    @Prop({required: false}) itemsCount: number;


    getField(item: TableItem, field: TableColumn) {
        let value = item.getField(field.fieldName);

        if (field.type && field.type === 'DateTime' && value) {
            value = value.toLocaleString();
        }

        return value;
    }

    getFieldClass(field: TableColumn): string {
        if (Object.prototype.hasOwnProperty.call(field, 'class')) {
            return field.class ?? '';
        }
        return '';
    }
}
